<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem" v-if="!newItem"/>
        </p>
        <app-content-title v-if="!newItem && !pending"
                           :title="item._show.name"/>
        <app-content-title v-if="newItem" :title="translations.newBlackoutContentTemplate"/>
      </div>
      <app-tabs
        :colsTabs="columnTabs"
        :shouldLoadFirstTab="newItem"
        :loadTab="params.tab"
        @appTabChanged="onAppTabChanged"
      >

      <div :title="translations.information">
        <app-settings @submit="onFormSubmit" :disabled="pending" title="Info">

      <div :title="translations.information">
          <app-settings-content>
            <app-settings-desc :title="translations.basicInfo">
              <p v-if="!newItem">
                <translate>Založeno</translate>
                :<br/>
                <span v-html="formatDateAdvanced(item._created)"/>
              </p>

              <p v-if="!newItem">
                <translate>Upraveno</translate>
                :<br/>
                <span v-html="formatDateAdvanced(item._updated)"/>
              </p>

              <p v-if="!newItem">
                  <translate>Počet blokací</translate>
                  :<br/>
                  {{ item._blockedBroadcastsCount }}
              </p>
            </app-settings-desc>

            <app-settings-options>
              <app-settings-col class="field_left">
                <app-settings-control>
                  <app-checkbox
                      name="enabled"
                      :title="translations.enabled"
                      :error="!!errors.first('enabled')"
                      v-model="formItem.enabled"
                  />
                </app-settings-control>

               <app-input
                    :label="translations.reason"
                    :error="errors.items.find(el => el.field === 'reason')"
                    v-model="formItem.reason"
                    name="reason"
                />

                  <app-datepicker
                      :label="translations.blockUntil"
                      :error="errors.items.find(el => el.field === 'blockUntil')"
                      v-model="formItem.blockUntil"
                      name="blockUntil"
                  />

                  <app-settings-select
                      required
                      :error="errors.items.find(el => el.field === 'showId')"
                      :label="translations.show"
                  >
                      <app-select
                          selectId="showId"
                          :options="showOptions"
                          v-model="formItem.showId"
                          name="showId"
                      />
                  </app-settings-select>

              </app-settings-col>

              <app-settings-col class="field_right">
                <app-settings-control>
                  <app-checkbox
                      name="applyToPastBroadcast"
                      :title="translations.applyToPastBroadcast"
                      :error="!!errors.first('applyToPastBroadcast')"
                      v-model="formItem.applyToPastBroadcast"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="reflectOverlaps"
                      :title="translations.reflectOverlaps"
                      :error="!!errors.first('reflectOverlaps')"
                      v-model="formItem.reflectOverlaps"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="allowCatchup"
                      :title="translations.allowCatchup"
                      :error="!!errors.first('allowCatchup')"
                      v-model="formItem.allowCatchup"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="allowTs"
                      :title="translations.allowTs"
                      :error="!!errors.first('allowTs')"
                      v-model="formItem.allowTs"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="allowPvr"
                      :title="translations.allowPvr"
                      :error="!!errors.first('allowPvr')"
                      v-model="formItem.allowPvr"
                  />
                </app-settings-control>
              </app-settings-col>
            </app-settings-options>
          </app-settings-content>
      </div>
      <div :title="translations.regionSettings">
        <app-settings-content>
          <app-settings-desc :title="translations.regionSettings" />

          <app-settings-options>
            <app-settings-col class="field_left">
                <app-input
                    :label="translations.allowedRegions"
                    :error="errors.items.find(el => el.field === 'allowedRegions')"
                    v-model="formItem.allowedRegions"
                    name="allowedRegions"
                />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.restrictedRegions"
                  :error="errors.items.find(el => el.field === 'restrictedRegions')"
                  v-model="formItem.restrictedRegions"
                  name="restrictedRegions"
              />
            </app-settings-col>
          </app-settings-options>
        </app-settings-content>

        </div>

        <div :title="translations.backofficeRelations">
          <app-settings-content v-if="backofficesList.length > 0">
              <app-settings-desc :title="translations.backofficeRelations" />

              <div class="right checkbox_group">
                  <ul>
                      <app-checkbox
                          v-for="backoffice in backofficesList"
                          list
                          :title="backoffice.name"
                          :key="backoffice.id"
                          :formValue="backoffice.id"
                          :checked="formItem.backofficeIds && formItem.backofficeIds.includes(backoffice.id)"
                          name="backofficeIds[]"
                      />
                  </ul>
              </div>

          </app-settings-content>
        </div>

        <div :title="translations.tvStations">
          <app-settings-content v-if="tvStationsList.length > 0">
              <app-settings-desc :title="translations.tvStations" />

              <div class="right checkbox_group">
                  <ul>
                      <app-checkbox
                          v-for="tvStation in tvStationsList"
                          list
                          :title="tvStation.name"
                          :key="tvStation.id"
                          :formValue="tvStation.id"
                          :checked="formItem.epgIds && formItem.epgIds.includes(tvStation.id)"
                          name="epgIds[]"
                      />
                  </ul>
              </div>
          </app-settings-content>

            <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'blackoutContentTemplates' }">
                <app-content-save-button :disabled="pending" @click="disallowBack"/>
            </app-settings-buttons>
        </div>
      </app-settings>
      </div>
      <div
          :title="translations.blackoutContents"
          :data-disabled-title="translations.blackoutContents"
          :data-disabled="!item || !item._id"
      >
        <blackout-contents
            :template-id="item._id"
            :wrap-in-app-content="false"
            :parentTitle="currentTitle"
        />
      </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'
import TvChannels from '@/views/TvChannel/TvChannels.vue'
import BlackoutContents from '@/views/BlackoutContent/BlackoutContents.vue'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'BlackoutContentTemplate',
  parentRouteName: 'blackoutContentTemplates',
  storeModuleName: 'blackoutContentTemplates',
  storeItemName: 'blackoutContentTemplate'
})

export default {
  name: 'blackout-content-template-item',
  components: { BlackoutContents, TvChannels },
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  data() {
    return {
      loadedShow: null,
      columnTabs: [
        0,
        1
      ]
    }
  },
  created() {
    if (typeof this.formItem.enabled === 'undefined') {
      this.formItem.enabled = true
      this.formItem.reflectOverlaps = true
      this.formItem.applyToPastBroadcast = false
    }

    this.getShowForNewItem()
    this.getTvStationsOrderedByName()
    this.getBackoffices()

    this.params.tab = 0
  },
  methods: {
    ...mapActions([
      'getTvStations',
      'getBackoffices',
      'getShow'
    ]),
    getShowForNewItem() {
      if (this.$route.name === 'blackoutContentTemplateNew') {
        this.getShow({
          params: { id: this.$route.params.showId }
        }).then((response) => {
          this.loadedShow = response.data.data
          this.formItem.showId = this.loadedShow._id
        }).catch((error) => {
          console.error('[404] Invalid show: ' + error.message)
          this.$router.push({ name: 'blackoutContentTemplates' })
        })
      }
    },
    getTvStationsOrderedByName() {
      this.getTvStations({
        params: {
          order: 'name',
          limit: 100000
        }
      })
    },
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('BlackoutContentTemplate')
      const response = await
      commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.$router.push({
          name: 'blackoutContentTemplate',
          params: {
            id: response.data.data._id
          }
        })
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    }
  },
  computed: {
    ...mapState({
      tvStationsList: (state, vm) => {
        return [
          ...state.tvStations.tvStations.map(({ _id, name }) => ({
            id: _id,
            name: name + ' (#' + _id + ')'
          }))
        ]
      },
      backofficesList: (state, vm) => {
        return [
          ...state.backoffices.backoffices.map(({ _id, name }) => ({
            id: _id,
            name: name
          }))
        ]
      }
    }),
    showOptions: function () {
      return this.loadedShow ? [
        {
          value: this.loadedShow._id,
          name: (this.loadedShow.name || this.loadedShow.originalName) + ' (#' + this.loadedShow._id + ')'
        }
      ] : (this.formItem._show ? [
        {
          value: this.formItem._show.id,
          name: (this.formItem._show.name || this.formItem._show.originalName) + ' (#' + this.formItem._show.id + ')'
        }
      ] : [])
    },
    translations() {
      return {
        blockUntil: this.$gettext('Blokovat do (včetně)'),
        blackoutContents: this.$gettext('Blokovaný obsah'),
        regionSettings: this.$gettext('Nastavení regionů'),
        backofficeRelations: this.$gettext('Backoffice'),
        newBlackoutContentTemplate: this.$gettext('Nová šablona blokování'),
        applyToPastBroadcast: this.$gettext('Aplikovat na odvysílané broadcasty (obsah CMS)'),
        tvStations: this.$gettext('EPG Stanice'),
        reason: this.$gettext('Důvod blokace'),
        list: this.$gettext('Seznam'),
        enabled: this.$gettext('Šablona aktivní'),
        information: this.$gettext('Informace'),
        format: this.$gettext('Formát'),
        basicInfo: this.$gettext('Základní údaje'),
        reflectOverlaps: this.$gettext('Použít reálné overlapy'),
        allowCatchup: this.$gettext('Povolit catch-up'),
        allowTs: this.$gettext('Povolit Timeshift'),
        allowPvr: this.$gettext('Povolit PVR'),
        allowedRegions: this.$gettext('Povolené regiony'),
        restrictedRegions: this.$gettext('Zakázané regiony'),
        show: this.$gettext('Pořad')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Šablony blokování'), link: { name: 'blackoutContentTemplates' } },
        this.item._id ? this.$gettext('Šablona blokování') : this.translations.newBlackoutContentTemplate
      ]
    }
  }
}
</script>
